import { render, staticRenderFns } from "./shebeimessage.vue?vue&type=template&id=19ad3ec9&scoped=true"
import script from "./shebeimessage.vue?vue&type=script&lang=js"
export * from "./shebeimessage.vue?vue&type=script&lang=js"
import style0 from "./shebeimessage.vue?vue&type=style&index=0&id=19ad3ec9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad3ec9",
  null
  
)

export default component.exports